import { client } from '@@api/client';
import { CONTENT_LANGUAGE_HEADER } from '@@api/constants/headers';
import { type ContentLanguage } from '@@lib/i18n/constants';

const PAGE_SIZE = 100;

export const tagListQuery = (
    query: { q?: string; active?: boolean },
    contentLocale: ContentLanguage,
) =>
    client.metadata.tags.getAll.infiniteQueryOptions({
        query: { ...query, size: PAGE_SIZE },
        headers: { [CONTENT_LANGUAGE_HEADER]: contentLocale },
    });
